import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=bfddcb7a&scoped=true&"
import script from "./userProfile.vue?vue&type=script&lang=js&"
export * from "./userProfile.vue?vue&type=script&lang=js&"
import style0 from "./userProfile.vue?vue&type=style&index=0&id=bfddcb7a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfddcb7a",
  null
  
)

export default component.exports